import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { intercomHmacResponse } from './types';

export const fetchIntercomHmac = async (): Promise<intercomHmacResponse> =>
	fetchJson('/gateway/api/jsm/onboarding/intercom/v1/hmac');
